module.exports = __webpack_public_path__ + "static/media/waiting.eb1e0be3.svg";